module.exports = __webpack_public_path__ + "img/maintenance.b2d07d2d.svg";